import BasePostGrid from "@PegasusCore/pegasus-one-post-grid/src/script";

class PostGrid extends BasePostGrid {
    gridId = null;
    hideNotFiltering = false;

    constructor(hideNotFiltering = false) {
        super();
        this.hideNotFiltering = hideNotFiltering;
    }

    init() {
        super.init();

        const filterableElement = this.$root.querySelector('[data-pegasus-filterable]');
        if (filterableElement) {
            this.gridId = filterableElement.dataset.pegasusFilterable;
        }

        window.addEventListener("pegasusgridfiltertoggle", (event) => {
            console.log("pegasusgridfiltertoggle", event.detail);
        
            if (event.detail.targetGridId === this.gridId) {
                this.currentFilters = event.detail.currentFilters;
        
                const hasFilters = Object.keys(this.currentFilters).length > 0;
        
                this.getAllPostGrids().forEach((container) => {
                    const grid = container.querySelector('[data-pegasus-filterable]');
                    const gridId = grid?.dataset.pegasusFilterable;
                    
                    console.log("Grid ID:", gridId, "Current Grid ID:", this.gridId);
        
                    if (hasFilters) {
                        if (gridId !== this.gridId) {
                            container.classList.add('hidden');
                        } else {
                            container.classList.remove('visible');
                        }
                    } else {
                        if (gridId !== this.gridId) {
                            container.classList.remove('hidden');
                        } else {
                            container.classList.add('visible');
                        }
                    }
                });
        
                this.fetchContent();
            }
        });
        
    }

    fetchContent(href = null) {
        if (!this.gridId) return;

        const elements = [
            'data-pegasus-filterable="' + this.gridId + '"'
        ];

        console.log("fetchContent", elements);

        let currentUrl = "";

        if (!Object.keys(this.currentFilters).length) {
            if (href) {
                currentUrl = href;
            } else {
                currentUrl = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
            }
        } else {
            currentUrl = this.buildUrl();
        }

        if (href) {
            currentUrl = href;
        }

        if (!this.isLoading) {
            this.isLoading = true;

            pegasus.ajaxContent(currentUrl, elements, {}, () => {
                this.isLoading = false;

                history.pushState(JSON.stringify(this.currentFilters), '', currentUrl);

                const offset = 200;
                const top = this.$root.getBoundingClientRect().top + window.pageYOffset - offset;
                window.scrollTo({
                    top: top,
                    behavior: 'smooth'
                });

                if (typeof window.modal !== "undefined") {
                    window.modal.init();
                }
            });
        }
    }

    /**
     * loadMore
     * 
     * Description: Loads the next page of posts below the current set of posts.
     * @return void
     */   
    loadMore() {
        const postGrid = this.$root.querySelector('[data-pegasus-filterable]');
        const dataSelector = '[data-pegasus-filterable="' + postGrid.dataset.pegasusFilterable + '"]';

        const href = this.$el.getAttribute("href");
        const container = [dataSelector];
        const elements = ['[data-pegasus-single-card]', '.Post__Grid-next-page'];

        if (!this.isLoading) {
            this.isLoading = true;

            pegasus.loadMoreContent(href, container, elements, {}, () => {
                this.isLoading = false;
                this.$el.parentElement.remove();

                if (typeof window.modal !== "undefined") {
                    window.modal.init();
                }
            });
        }
    }

    getAllPostGrids() {
        return Array.from(document.querySelectorAll("[data-pegasus-filterable]"))
            .map(el => el.closest(".Pegasus__Container"))
            .filter(Boolean);
    }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("postGrid", (hideNotFiltering) => new PostGrid(hideNotFiltering));
});
